var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass:
                "table table-light table-light table-bordered table-hover",
              attrs: {
                columns: _vm.configurations.columns,
                data: _vm.configurations.data
              }
            },
            [
              _vm.configurations.data.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.configurations.data, function(item, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: { inactive: item.status === "0" }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(item.key))]),
                          _vm._v(" "),
                          item.value.length > 1
                            ? _c("td", [_vm._v(_vm._s(item.value))])
                            : item.value == 1
                            ? _c("td", [
                                _c("i", { staticClass: "fa fa-check" })
                              ])
                            : item.value == 0
                            ? _c("td", [
                                _c("i", { staticClass: "fa fa-close" })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { role: "group" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: _vm.configurations.tooltips.edit,
                                        expression:
                                          "configurations.tooltips.edit",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-info btn-sm",
                                    on: {
                                      click: function($event) {
                                        return _vm.editConfiguration(item)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-edit" })]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-items-center mb-1" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "h2" }, [_vm._v("Configurations")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a2c18d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a2c18d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Configurations/Configurations.vue
// module id = H1Db
// module chunks = 0